import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-dashboard',
  templateUrl: './icon-dashboard.component.html',
  styles: []
})
export class IconDashboardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
